import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  ActiveInactiveServices,
  createServices,
  deleteServices,
  getAllActiveServices,
  getAllServices,
  getServicesByID,
  ServicesDetailsImageUpload,
  updateServices,
} from "./services/services.services";
import { IService, IServices } from "./servicesModal";

const initialState: IServices = {
  loading: false,
  formLoading: false,
  error: "",
  ServiceID: null,
  ServiceList: [],
  ServiceDetail: {
    ID: null,
    CoreServiceID: null,
    Title: "",
    SubTitle: "",
    PageDetails: "",
    CtaTemplate: "",
    CtaImage: null,
    BreakDown: "",
    BreakDownImage: null,
    URL: "",
    IsActive: 1,
  },
};

const serviceSlice = createSlice({
  name: "services",
  initialState,
  reducers: {
    clearServiceDetails: (state) => {
      state.ServiceDetail = initialState.ServiceDetail;
    },
    setServiceID: (state, action) => {
      state.ServiceID = action.payload;
    },
    clearServiceID: (state) => {
      state.ServiceID = initialState.ServiceID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllServices.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllServices.fulfilled,
      (state, action: PayloadAction<IService[]>) => {
        state.loading = false;
        state.ServiceList = action.payload || [];
      }
    );
    builder.addCase(getAllServices.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.ServiceList = [];
    });
    builder.addCase(createServices.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(createServices.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(createServices.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateServices.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(updateServices.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updateServices.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteServices.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteServices.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteServices.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getServicesByID.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getServicesByID.fulfilled, (state, action: any) => {
      state.loading = false;
      state.ServiceDetail = action.payload;
    });
    builder.addCase(getServicesByID.rejected, (state, action) => {
      state.loading = false;
      state.ServiceDetail = initialState.ServiceDetail;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAllActiveServices.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveServices.fulfilled,
      (state, action: PayloadAction<IService[]>) => {
        state.loading = false;
        state.ServiceList = action.payload || [];
      }
    );
    builder.addCase(getAllActiveServices.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.ServiceList = [];
    });
    builder.addCase(ActiveInactiveServices.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(ActiveInactiveServices.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(ActiveInactiveServices.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    // IMAGE UPLOAD
    builder.addCase(ServicesDetailsImageUpload.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(ServicesDetailsImageUpload.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(ServicesDetailsImageUpload.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const { clearServiceDetails, clearServiceID, setServiceID } =
  serviceSlice.actions;
export default serviceSlice.reducer;
